<template>
  <div>
    <div class="header">
      <h1>
        <transition
          mode="out-in"
          enter-active-class="animated fadeIn"
          leave-active-class="animated faster fadeOut"
        >
          <i class="fas fa-arrow-left" id="arrow" @click="back"></i>
        </transition>
        Profil
        <transition
          mode="out-in"
          enter-active-class="animated fadeIn"
          leave-active-class="animated faster fadeOut"
        >
          <!--bedz u desnom uglu se prikazuje samo kada je otvorena kartica-->
          <i class="fas fa-user badge--mod"></i>
        </transition>
      </h1>
    </div>
    <div class="body-wrapper">
      <modal-confirm-action
        v-if="showDeleteDocumentModal"
        @close="showDeleteDocumentModal = false"
        @confirm="deleteDocument"
        :isLoading="deleteLoading"
        title="Brisanje dokumenta"
      >
        <div>Da li ste sigurni da želite da obrišete dokument:</div>
        <div>{{ documentToDelete.file_name }}</div>
      </modal-confirm-action>
      <div class="left-column">
        <div class="box">
          <div class="title-wrapper flex profile-info">
            <b class="title">Informacije</b>

            <i v-if="!editMode" class="fas fa-pen" @click="enableEdit"></i>
            <i
              v-if="editMode"
              class="fas fa-times disable-edit-btn"
              @click="disableEdit"
            ></i>
          </div>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
          <div class="info-box">
            <div
              class="image-wrapper"
              @click="upload"
              :class="{ 'image-wrapper-edit': editMode }"
            >
              <input
                type="file"
                accept="image/gif, image/jpeg, image/png"
                ref="input"
                hidden
                @change="setPicture"
              />
              <transition name="fade" mode="out-in">
                <img :key="url" :src="url" @click="upload" />
              </transition>
              <div class="image-edit">
                <i class="fas fa-pen"></i>
              </div>
            </div>
            <div class="left-column" v-if="!loading">
              <div class="div-description single-info">
                <small class="label">Prezime i ime</small>
                <input
                  type="text"
                  autocomplete="false"
                  class="form-control form-control-lg"
                  v-model="username"
                  v-if="editMode"
                />
                <h4 v-if="!editMode" class="value">{{ user.username }}</h4>
              </div>
              <div class="fullname single-info">
                <small class="label">Telefon</small>
                <input
                  type="text"
                  class="form-control form-control-lg"
                  v-model="phone"
                  v-if="editMode"
                />
                <h4 v-if="!editMode" class="value">
                  {{ user.phone ? user.phone : '/' }}
                </h4>
              </div>
              <div class="fullname single-info">
                <small class="label">Email</small>
                <h4 class="value">
                  {{ user.email }}
                </h4>
              </div>
            </div>
          </div>
          <div class="button-wrapper button-wrapper-profile-info">
            <button
              class="btn btn-primary btn--load"
              @click="save"
              v-if="editMode"
            >
              <slot>
                <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
              </slot>
              <slot v-if="!loading">Sačuvaj</slot>
            </button>
          </div>
          <div class="change-password-wrapper">
            <h5 v-if="editMode">Izmena lozinke</h5>
            <label v-if="editMode" class="label">Trenutna lozinka </label>
            <input
              type="password"
              class="form-control form-control-lg"
              v-model="currentPassword"
              v-if="editMode"
            />
            <label v-if="editMode" class="label">Nova lozinka</label>
            <input
              type="password"
              class="form-control form-control-lg"
              v-model="newPassword"
              v-if="editMode"
            />
            <label v-if="editMode" class="label">Ponovite novu lozinku</label>
            <input
              type="password"
              class="form-control form-control-lg"
              v-model="newPasswordRepeat"
              v-if="editMode"
            />
            <div class="footer">
              <div class="error">
                <transition enter-active-class="animated shake">
                  <p class="err-msg" v-if="errorMessage != ''">
                    {{ errorMessage }}
                  </p>
                </transition>
              </div>
            </div>
            <div class="button-wrapper">
              <button
                class="btn btn-primary btn--load text-center"
                :disabled="
                  currentPassword.length == 0 ||
                    newPassword.length == 0 ||
                    newPasswordRepeat.length == 0
                "
                @click="changePassword"
                v-if="editMode"
              >
                <slot>
                  <spinner
                    :size="20"
                    line-fg-color="#00796b"
                    v-if="loadingPassword"
                  />
                </slot>
                <slot v-if="!loadingPassword">Sačuvaj</slot>
              </button>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="title-wrapper">
            <b class="title">Dokumenta</b>
            <a class="btn" @click="opetAddDocument()">
              <i class="fas fa-plus"></i>
            </a>
          </div>
          <spinner :size="20" line-fg-color="#00796b" v-if="loadingDocuments" />
          <div class="table" v-if="!loadingDocuments">
            <div v-if="userDocuments.length == 0">
              Ne postoje dokumenta
            </div>
            <div ref="rows" class="rows">
              <div class="row" v-for="row in userDocuments" :key="row.id">
                <div class="parent">
                  <a
                    class="column document-name"
                    target="_blank"
                    style="flex: 6"
                    :href="baseObjectStorageUrl + row.link"
                  >
                    {{ row.file_name }}
                  </a>
                  <div class="column actions" style="flex: 1">
                    <a class="btn" @click="openDeleteDocument(row)">
                      <i class="fas fa-minus"></i>
                    </a>
                    <a
                      class="btn"
                      target="_blank"
                      :href="baseObjectStorageUrl + row.link"
                    >
                      <i class="fas fa-file-download"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapState, mapMutations, mapActions } from 'vuex';
import modalConfirmAction from '@/components/modal/ModalConfirmAction.vue';

const util = {
  mapNotificationSettings(notificationSettings, fromNumToBoolean = true) {
    if (fromNumToBoolean) {
      return {
        comment_notification: notificationSettings.comment_notification !== '0',
        event_notification: notificationSettings.event_notification !== '0',
        message_notification: notificationSettings.message_notification !== '0',
        post_notification: notificationSettings.post_notification !== '0',
        ticket_notification: notificationSettings.ticket_notification !== '0',
        vote_notification: notificationSettings.vote_notification !== '0'
      };
    } else {
      return {
        comment_notification:
          notificationSettings.comment_notification === false ? 0 : 1,
        event_notification:
          notificationSettings.event_notification === false ? 0 : 1,
        message_notification:
          notificationSettings.message_notification === false ? 0 : 1,
        post_notification:
          notificationSettings.post_notification === false ? 0 : 1,
        ticket_notification:
          notificationSettings.ticket_notification === false ? 0 : 1,
        vote_notification:
          notificationSettings.vote_notification === false ? 0 : 1
      };
    }
  }
};

export default {
  components: {
    modalConfirmAction
  },
  async created() {
    await this.refreshUserData();
    this.url = this.baseUrl + this.user.profile_pic_URL.link;
    const userDocuments = await this.getUserDocuments();
    this.setUserDocuments(userDocuments);
    this.getNotificationStatus();
  },
  computed: {
    ...mapState('modal', ['userDocuments']),
    ...mapState(['loading'])
  },
  data() {
    // TODO EDITMODE BACK TO FALSE !!!!!!
    return {
      baseObjectStorageUrl: process.env.VUE_APP_OBJECT_STORAGE_URL,
      user: this.$store.getters.getUser,
      baseUrl: process.env.VUE_APP_OBJECT_STORAGE_URL,
      editMode: false,
      changePasswordMode: false,
      notificationStatus: null,
      notificationsStatusDummy: {},
      file: null,
      url: '',
      phone: '',
      username: '',
      deviceID: null,
      currentPassword: '',
      newPassword: '',
      newPasswordRepeat: '',
      errorMessage: '',
      loadingPassword: false,
      loadingDocuments: true,
      showDeleteDocumentModal: false,
      documentToDelete: null,
      deleteLoading: false
    };
  },
  methods: {
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapMutations('modal', ['showModal', 'setUserDocuments', 'setManager']),

    back() {
      this.$router.back();
    },
    async deleteDocument() {
      try {
        this.deleteLoading = true;
        const data = {
          mediaId: this.documentToDelete.id
        };
        await axios.delete(`user/${this.user.id}/user-document`, {
          data: data
        });
        const userDocuments = await this.getUserDocuments();
        this.setUserDocuments(userDocuments);
        this.deleteLoading = false;
        this.showSuccessModal();
        this.showDeleteDocumentModal = false;
      } catch (error) {
        console.log(error);
        this.deleteLoading = false;
        this.showFailModal();
      }
    },
    opetAddDocument() {
      this.setManager({
        user: {
          id: this.user.id
        }
      });
      this.showModal('ModalContentAddUserDocument');
    },
    openDeleteDocument(document) {
      this.documentToDelete = document;
      this.showDeleteDocumentModal = true;
    },
    changeNotificationStatus() {
      axios
        .post('user/set-notifications-settings', {
          ...util.mapNotificationSettings(this.notificationStatus, false),
          device_id: this.deviceID
        })
        .then(res => {
          // console.log(res);
        });
    },
    getNotificationStatus() {
      this.deviceID = localStorage.getItem('deviceID');

      if (this.deviceID) {
        axios
          .post('user/get-notifications-settings', {
            device_id: this.deviceID
          })
          .then(({ data }) => {
            this.notificationStatus = util.mapNotificationSettings(data.device);
          });
      }
    },
    save() {
      if (this.loading) {
        return;
      }
      this.loadingStarted();
      if (this.file != null) {
        axios
          .post('/media/add', this.formatMediaForSubmit(), {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(({ data }) => {
            this.updateUser(data.ids[0]);
          })
          .catch(error => {
            this.loadingFinished();
            console.log(error);
            this.showFailModal();
          });
      } else {
        this.updateUser(null);
      }
    },
    async changePassword() {
      if (this.currentPassword.trim() == '') {
        this.errorMessage = 'Morate uneti trenutnu lozinku.';
        return;
      }
      if (this.newPassword.trim() == '') {
        this.errorMessage = 'Morate uneti novu lozinku.';
        return;
      }
      if (this.newPassword.trim().length < 6) {
        this.errorMessage = 'Nova lozinka mora imati najmanje 6 karaktera.';
        return;
      }
      if (this.newPassword.trim() != this.newPasswordRepeat.trim()) {
        this.errorMessage = 'Nova i ponovljena lozinka se ne poklapaju.';
        return;
      }
      try {
        this.loadingPassword = true;
        await axios.post('user/change-password', {
          old_password: this.currentPassword,
          new_password: this.newPassword
        });
        this.loadingPassword = false;
        this.currentPassword = '';
        this.newPassword = '';
        this.newPasswordRepeat = '';
        this.disableChangePassword();
        this.showSuccessModal('Lozinka uspešno promenjena');
      } catch (error) {
        this.loadingPassword = false;
        this.showFailModal();
      }
    },
    updateUser(picId) {
      if (this.deviceID) {
        this.changeNotificationStatus();
      }

      axios
        .post('user/edit', {
          full_name: this.username,
          phone: this.phone,
          profile_pic_URL: picId
        })
        .then(({ data }) => {
          this.user.username = data.data.full_name;
          this.user.phone = data.data.phone;
          this.user.profile_pic_URL = data.data.profile_pic_URL;
          this.url = this.baseUrl + this.user.profile_pic_URL.link;
          this.loadingFinished();
          this.editMode = false;
          this.errorMessage = '';
          this.file = null;
          this.clearInput();
        })
        .catch(error => {
          this.loadingFinished();
          console.log(error);
          this.showFailModal();
        });
    },
    async refreshUserData() {
      this.loadingStarted();
      const data = await axios.get('user/refresh-user-data');
      this.user.username = data.data.full_name;
      this.user.phone = data.data.phone;
      this.user.profile_pic_URL = data.data.profile_pic_URL;
      this.url = this.baseUrl + this.user.profile_pic_URL.link;
      this.loadingFinished();
    },
    async getUserDocuments() {
      try {
        const result = await axios.get(`user/${this.user.id}/user-document`);
        this.loadingDocuments = false;
        return result.data.data;
      } catch (error) {
        this.loadingDocuments = false;
        throw error;
      }
    },
    enableEdit() {
      this.phone = this.user.phone;
      this.username = this.user.username;
      this.editMode = true;
      if (this.deviceID) {
        Object.assign(this.notificationsStatusDummy, this.notificationStatus);
      }
    },
    disableEdit() {
      if (this.loading) {
        return false;
      }
      this.phone = this.user.phone;
      this.username = this.user.username;
      this.editMode = false;
      this.url = this.baseUrl + this.user.profile_pic_URL.link;
      this.file = null;
      this.clearInput();
      if (this.deviceID) {
        Object.assign(this.notificationStatus, this.notificationsStatusDummy);
      }
    },
    enableChangePassword() {
      this.changePasswordMode = true;
    },
    disableChangePassword() {
      this.changePasswordMode = false;
    },
    upload() {
      if (this.editMode) this.$refs.input.click();
    },
    setPicture(event) {
      if (event.target.files[0].size > 5122059) {
        this.showFailModal('Fajl ne može biti veći od 5MB');
        return;
      }
      this.url = URL.createObjectURL(event.target.files[0]);
      this.file = event.target.files[0];
    },
    clearInput() {
      this.$refs.input.value = '';
    },
    formatMediaForSubmit() {
      let fd = new FormData();
      if (this.file != null) fd.append('files[]', this.file, this.file.name);

      fd.append('type', 'user');
      fd.append('community_id', '');
      return fd;
    }
  }
};
</script>

<style lang="scss" scoped>
.disable-edit-btn {
  color: red !important;
  font-size: 1.2em;
}
.button-wrapper-profile-info {
  margin-top: 8px;
}
.button-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.change-password-wrapper {
  margin-top: 32px;
  margin-left: 135px;
  h5 {
    padding-top: 8px;
    border-top: 1px solid var(--primary-color);
  }
}
.profile-info {
  width: 100%;
  display: flex;
  align-items: center;
  i {
    margin-left: auto;
    color: var(--primary-color);
    cursor: pointer;
  }
}
.box {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0), 0 2px 15px rgba(0, 0, 0, 0.24);
  margin-bottom: 1rem;
  padding: 16px;
  position: relative;
}
.badge--mod {
  position: absolute;
  right: 0;
  left: unset;
  border-radius: 50%;
  padding: 5px;
  margin-right: 10px;
}
.header {
  padding: 10px 10px 0 10px;
}
.body-wrapper {
  display: flex;
  height: 100%;
  .left-column {
    flex: 3;
    height: 100%;
    .info-box {
      width: 100%;
      // border: 1px solid var(--primary-color);
      border-radius: 4px;
      display: flex;
      // align-items: flex-end;
      // padding: 8px 8px 8px 0;
      padding: 0;
      .user-image {
        // flex: 3;
        padding: 2px 16px 8px 4px;
        display: flex;
        align-items: center;
        img {
          height: 100px;
          width: 100px;
          -o-object-fit: cover;
          object-fit: cover;
          border-radius: 50%;
        }
      }
      .left-column {
        flex: 5;
        display: flex;
        flex-direction: column;
      }
      .right-column {
        flex: 3;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
      }

      .single-info {
        // margin-left: 8px;
        // border: 1px solid black;
        display: flex;
        flex-direction: column;
        padding-top: 2px;
        margin-bottom: 2px;
        &.balance {
          &.positive {
            .value {
              color: var(--primary-color);
            }
          }
          &.negative {
            .value {
              color: rgba(220, 53, 70, 1);
            }
          }
          small {
            text-align: right;
          }
        }
      }

      h2,
      h4 {
        padding: 0;
        margin: 0;
        word-break: break-word;
      }
    }
    .invoices {
      width: 100%;
      height: calc(100% - 220px);
    }
  }
  .right-column {
    flex: 4;
    margin-left: 1rem;
  }
  .table {
    margin-bottom: 0;
    font-size: 0.9rem;
    position: relative;
    z-index: 0;
    height: calc(100% - 30px);

    .right-padding {
      .column:last-of-type {
        padding-right: 0.7rem;
      }
    }

    .rows {
      max-height: calc(100% - 30px);
      overflow-y: auto;

      .row {
        width: 100% !important;
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .parent {
          padding: 3px 0;
          width: 100%;
          display: flex;
          .more {
            margin-right: 8px;
          }
        }

        .more-btn {
          cursor: pointer;
          i {
            transform: rotate(0);
            transition: transform 0.2s;
          }
        }

        .items {
          display: none;
          width: 100%;
          flex-direction: column;
          padding-left: 8px;
          .row {
            display: flex;
            flex-direction: row;
            background: rgb(240, 240, 240);
            padding-left: 6px;
            border-radius: 4px;
            margin-bottom: 2px;
          }
          .row-desc {
            font-weight: bold;
          }
          .column {
            word-break: break-word;
          }
        }

        &.expanded-content {
          .items {
            display: flex;
          }
          .more-btn {
            i {
              transform: rotate(90deg);
            }
          }
        }

        .column {
          text-align: left;
          display: flex;
          align-items: center;
        }
      }
    }
    .labels {
      border-bottom: 1px solid gray;
      .column {
        font-weight: 600;
      }
    }
    .actions {
      display: flex;
      justify-content: flex-end;
      padding-right: 10px;
      .btn {
        background: rgb(230, 230, 230);
        margin: 0 4px;
        height: 24px;
        width: 24px;
        padding: 0 0 2px 2px;
        position: relative;
        &:hover {
          background: rgb(210, 210, 210);
        }
        i {
          font-size: 0.9rem;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: var(--primary-color);
        }
      }
    }
  }
}

.actions {
  display: flex;
  justify-content: flex-end;
  padding-right: 10px;
  .btn {
    background: rgb(230, 230, 230);
    margin: 0 4px;
    height: 24px;
    width: 24px;
    padding: 0 0 2px 2px;
    position: relative;
    &:hover {
      background: rgb(210, 210, 210);
    }
    i {
      font-size: 0.9rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: var(--primary-color);
    }
  }
}
.rows {
  max-height: calc(100% - 30px);
  overflow-y: auto;

  .row {
    width: 100% !important;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    .parent {
      padding: 3px 0;
      width: 100%;
      display: flex;
      .more {
        margin-right: 8px;
      }
    }

    .more-btn {
      cursor: pointer;
      i {
        transform: rotate(0);
        transition: transform 0.2s;
      }
    }

    .items {
      display: none;
      width: 100%;
      flex-direction: column;
      padding-left: 8px;
      .row {
        display: flex;
        flex-direction: row;
        background: rgb(240, 240, 240);
        padding-left: 6px;
        border-radius: 4px;
        margin-bottom: 2px;
      }
      .row-desc {
        font-weight: bold;
      }
      .column {
        word-break: break-word;
      }
    }

    &.expanded-content {
      .items {
        display: flex;
      }
      .more-btn {
        i {
          transform: rotate(90deg);
        }
      }
    }

    .column {
      text-align: left;
      display: flex;
      align-items: center;
    }
  }
}
.title-wrapper {
  margin-bottom: 12px;
  .title {
    font-size: 1.2rem;
    color: black;
    padding-bottom: 4px;
    border-bottom: 1px solid var(--primary-color);
  }

  .btn {
    color: var(--primary-color);
    background: #e6e6e6;
    padding: 2px 5px;
    font-size: 0.9rem;
    float: right;
    margin-right: 14px;
    &:hover {
      background: rgb(210, 210, 210);
    }
  }

  .icons-wrapper {
    display: inline-block;
    margin-left: auto;
    font-size: 1.4rem;
    i {
      padding: 7px 5px;
    }
    .box-icon {
      // position: absolute;
      // top: 0.8rem;
      // right: 0.8rem;
      color: var(--primary-color);
    }
    .invite-members-icon {
      background-color: #e6e6e6;
      padding: 7px 5px;
      border-radius: 5px;
      transition: background-color 0.2s;
    }

    .invite-members-icon:hover {
      background-color: #d2d2d2;
      cursor: pointer;
    }

    .icon-notice {
      color: #d2d2d2;
      transition: color 0.2s;
    }

    .icon-notice:hover {
      color: #dc3546;
      cursor: pointer;
    }

    .icon-default {
      color: #d2d2d2;
      transition: color 0.2s;
    }

    .icon-default:hover {
      color: var(--primary-color);
      cursor: pointer;
    }
  }
}
.information {
  label {
    font-size: 1.2em;
    font-weight: bold;
  }
}
.btn-edit-profile {
  width: 80%;
}
.btn-change-password {
  width: 100%;
}
.btn-edit-profile-action {
  width: 40% !important;
}
.footer {
  display: block;
  width: 100%;
  text-align: center;
  margin-top: 8px;
}
.error {
  float: left;
  // margin-left: 15px;
}

.err-msg {
  text-align: center;
  color: red;
}
.change-password {
  width: 80%;
  margin: 16px auto;
  font-size: 25px !important;
}
.notification-options {
  margin: auto 0 auto 50px;
  .checkbox-lbl {
    margin-left: 5px;
    font-size: 18px;
  }
}

.data-wrapper {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
}
.btn--mod {
  border: 1px solid var(--primary-color);
}

.btn--load {
  width: 90px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
 {
  opacity: 0;
}

.btn--notification {
  margin: auto 0 auto 20px;
}

.image-wrapper-edit {
  .image-edit {
    opacity: 1;
    cursor: pointer;
  }
}

.image-edit {
  border-radius: 50%;
  text-align: center;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  padding-top: 45%;
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  transition: opacity 0.3s;

  i {
    font-size: 20px;
    color: white;
  }
}

.btn--edit {
  position: absolute;
  background-color: var(--primary-color);
  border: none;
  border-radius: 50%;
  font-size: 20px;
}

.btn--edit:active,
.btn--edit:focus {
  box-shadow: none;
  outline: none;
}

.lb--mod {
  color: var(--primary-color);
  font-size: 25px;
}

.page-wrapper {
  padding-top: 10vh;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

img {
  height: 200px;
  width: 200px;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 50%;
}

img:hover {
  cursor: pointer;
}

.icon--mod {
  color: #3a3a3a;
}

.icon--mod:hover {
  cursor: pointer;
  color: white;
  transition: color 0.25s;
}

.card {
  border-color: var(--primary-color);
  min-width: 600px;
  min-height: 320px;
  -webkit-box-shadow: 0px 0px 49px -15px rgba(0, 0, 0, 1);
  -moz-box-shadow: 0px 0px 49px -15px rgba(0, 0, 0, 1);
  box-shadow: 0px 0px 49px -15px rgba(0, 0, 0, 1);
  padding: 50px;
}

.image-wrapper {
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  height: 100%;
  position: relative;
  overflow: hidden;
  margin: auto 35px auto 0;
  img {
    height: 100px;
    width: 100px;
    -o-object-fit: cover;
    object-fit: cover;
    border-radius: 50%;
  }
}

.info-wrapper {
  /*flex-flow: column wrap;*/
  flex-direction: column;
  justify-content: left;
  /*margin-top: 40px;*/
}
.info-wrapper {
  /*flex-flow: column wrap;*/
  flex-direction: column;
  justify-content: left;
  /*margin-top: 40px;*/
}

.button-wrapepr {
  display: flex;
  justify-content: center;
}
.button-wrapepr {
  display: flex;
  justify-content: center;
}

.title {
  border-bottom: solid 2px grey;
  display: inline-block;
}
</style>
